import dynamic from 'next/dynamic';
import loading from '../../lib/loading';

const DynamicAbTest = dynamic(() => import('../AbTest'), {
  ssr: false,
  loading,
});

export default DynamicAbTest;
